import TextField from '@app/src/components/Ui/TextField'
import type { RequestItem } from '@app/src/types/resourceExplorer'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

type TextQuestionInputFieldProps = {
  name: string
  requestItem: RequestItem
  disabled?: boolean
  hasError?: boolean
  error?: string
  hasAppliedSuggestion: boolean
}

const TextQuestionInputField: React.FC<TextQuestionInputFieldProps> = ({
  name,
  requestItem,
  disabled,
  hasError,
  error,
  hasAppliedSuggestion,
}) => {
  const { register, clearErrors } = useFormContext()
  const { formatMessage } = useIntl()

  return (
    <TextField
      required
      inputRef={register}
      name={name}
      label={formatMessage({ id: 'reporting.questionType.Text' })}
      disabled={disabled}
      error={hasError}
      helperText={error}
      type="text"
      multiline
      size="small"
      onChange={(): void => {
        if (hasError) clearErrors(`${requestItem.id}`)
      }}
      InputLabelProps={{
        shrink: hasAppliedSuggestion ? true : undefined,
      }}
      sx={{
        width: '100%',
      }}
    />
  )
}

export default TextQuestionInputField
